import ConfiguratorSelect from './configurator-select';

class ConfiguratorSoftwareSelect {
    constructor() {
        this.software = new ConfiguratorSelect('.js-software-select');
    }

    _events() {
        const queryKey = this.software.select.data('query-key');
        const url = new URL(location.href);
        this.software.select.on('change', (e) => {
            const value = e.target.value;
            url.searchParams.set(queryKey, value);
            location.href = url.href;
        });
    };

    init() {
        if (this.software.select.length) {
            try {
                this._events();
            } catch (e) {
            }
        }
    }

}

export default ConfiguratorSoftwareSelect;
